import { Injectable } from '@angular/core';
import { UtilidadesService } from '../utilidades/utilidades.servicios.index';
import { Observable } from 'rxjs';
import { vProductoPaginadoModel } from '../Modelo/vProducto.model';
import { IPaginacion } from '../Modelo/paginacion.model';

@Injectable({
    providedIn: 'root'
})
export class ProductosService {

    constructor(
        private Utilidades: UtilidadesService
    ) { }

    public Lista(filtro, sortingId?): Observable<vProductoPaginadoModel> {
        if (sortingId) {
            filtro.SortingOrder = "asc";
            filtro.SortingCategory = sortingId
        }
        return this.Utilidades.Post("Productos", filtro);
    }

    public ObtenerPagina(filtro, nroPagina: number): Observable<vProductoPaginadoModel> {
        return this.Utilidades.Post("Productos/" + nroPagina, filtro);
    }
}